'use strict';

var React = require('react');
var cx = require('classnames');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","labelText":"arrive_Checkbox__labelText","labelText-left":"arrive_Checkbox__labelText-left","labelText-right":"arrive_Checkbox__labelText-right","checkMark":"arrive_Checkbox__checkMark","checkboxContainer":"arrive_Checkbox__checkboxContainer","disabled":"arrive_Checkbox__disabled","checked":"arrive_Checkbox__checked","invalid":"arrive_Checkbox__invalid"};

var Checkbox = /*#__PURE__*/React__default["default"].forwardRef(function (_ref, ref) {
  var _cx;

  var checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      label = _ref.label,
      labelDirection = _ref.labelDirection,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      style = _ref.style;
  var labelElement = /*#__PURE__*/React__default["default"].createElement("span", {
    className: cx__default["default"](styles.labelText, styles["labelText-".concat(labelDirection)])
  }, label);
  var classes = cx__default["default"](styles.checkboxContainer, className, (_cx = {}, _defineProperty(_cx, styles.checked, checked), _defineProperty(_cx, styles.disabled, disabled), _defineProperty(_cx, styles.invalid, invalid), _cx));
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("label", {
    className: classes,
    style: style
  }, labelDirection === 'left' && labelElement, /*#__PURE__*/React__default["default"].createElement("input", {
    "aria-checked": checked,
    checked: checked || false,
    disabled: disabled,
    name: name,
    onChange: onChange,
    tabIndex: tabIndex,
    type: "checkbox",
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: styles.checkMark
  }), labelDirection === 'right' && labelElement));
});
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  /** show current state of checkbox */
  checked: PropTypes__default["default"].bool,
  className: PropTypes__default["default"].string,
  disabled: PropTypes__default["default"].bool,
  invalid: PropTypes__default["default"].bool,
  label: PropTypes__default["default"].string,

  /** Show values on left or right of checkbox (Allowed values: 'right' or 'left') */
  labelDirection: PropTypes__default["default"].oneOf(['right', 'left']),

  /** Add name attribute to checkbox */
  name: PropTypes__default["default"].string,
  onChange: PropTypes__default["default"].func.isRequired,
  style: PropTypes__default["default"].object,
  ref: PropTypes__default["default"].oneOfType([PropTypes__default["default"].func, PropTypes__default["default"].shape({
    current: PropTypes__default["default"].elementType
  })])
};
Checkbox.defaultProps = {
  checked: null,
  className: null,
  disabled: false,
  invalid: false,
  label: '',
  labelDirection: 'right',
  name: null,
  style: null,
  ref: null
};

module.exports = Checkbox;
